export default __webpack_public_path__ + "images/S8.5c21905.png";